<div class="container dashboard-wrapper">
    <div class="row dashboard-header">
        <div class="col-md-6">
            <div class="d-flex">
                <div class="">
                    <div class="user_pic">
                        <div class="user_pic_placeholder">SD</div>
                    </div>
                </div>
                <div class="flex-grow-1">
                    <h1>
                        Поліна<br>Кіяшко
                    </h1>
                    <br>
                    <div class=" mt-2  ">
                       <span class="email-input ">
                           <input class="form-control" placeholder="Email">
                       </span>
                    </div>
                    <h3>
                        Основний запит
                    </h3>
                    <p class="mb-2 d-block">
                        Часто виникають такі симптоми: - Постійне відчуття тривоги та занепокоєння- Проблеми зі сном-
                        Дратівливість і нетерпимість до дрібниць- Фізичні симптоми, такі як головний біль і напруження в
                        м'язах Мені важко контролювати свої емоції та зосереджуватись на важливих справах. Я б хотів
                        зрозуміти, що може бути причиною цих симптомів і як з ними впоратися.
                    </p>
                    <a class="btn btn-link read-more pl-0">
                        Читати повністю
                        <i class="bi bi-chevron-right "></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-md-6 calendar-wrapper">
            <!--            <app-dashboard-calendar></app-dashboard-calendar>-->
            <app-tracker-calendar></app-tracker-calendar>
            <div class="d-flex justify-content-between pl-4">
                <p>
                    Керуйте зручно своїми записами<br>та створюйте нові.
                </p>
                <button class="btn_primary_outline hover_action " (click)="newSession()">
                    Додати запис
                    <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="dashboard-container">
        <div class="row">
            <div class="col-md-7 col-12 p-0">
                <div class="list-header">
                    <h2>Історія клієнта</h2>

                    <div class="d-inline-block mb-2" ngbDropdown #myDrop="ngbDropdown">
                        <button
                                type="button"
                                class="btn btn-link text-dark me-2"
                                id="dropdownManual"
                                ngbDropdownAnchor
                                (focus)="myDrop.open()"
                        >
                            <b>Всі результати</b>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownManual">
                            <button ngbDropdownItem>Action - 1</button>
                            <button ngbDropdownItem>Another Action</button>
                            <button ngbDropdownItem>Something else is here</button>
                        </div>
                    </div>
                </div>

                <ul class="list-group">
                    <li class="list-group-item" *ngFor="let item of latestList">
                        <div>
                            <div class="user_pic" *ngIf="item.img"
                                 [ngStyle]="{backgroundImage: 'url(./assets/danilov.jpg)'}"></div>
                            <div class="user_pic" *ngIf="!item.img">
                                <div class="user_pic_placeholder">SD</div>
                            </div>
                        </div>
                        <div class="item-content">
                            <div class="item-header">
                                <div class="title">
                                    <div class="name">Serhiy Danilov</div>
                                    <p>Проходження тестів</p>
                                </div>
                                <div class="info">
                                    <span><i class="bi bi-clock"></i>16:00</span>
                                    <span><i class="bi bi-calendar"></i>17 березня 2024</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8 col-12">
                                    <div *ngIf="item?.results?.length" class="results">
                                        <div class="result-item" *ngFor="let result of item.results">
                                            {{result.title}}
                                            <i class="bi bi-circle-fill" [ngStyle]="{'color': result.color}"></i>
                                            <div class="divider"></div>
                                        </div>
                                    </div>
                                    <div>
                                        <p *ngIf="item?.text">
                                            Основний запит: Часто виникають такі симптоми:
                                            - Постійне відчуття тривоги та...
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-4 col-12 d-flex align-items-end">
                                    <div class="repeat_button">
                                        <button class="btn_primary_outline  d-flex justify-content-between align-items-center">
                                            Повторити
                                            <svg width="16" height="14" viewBox="0 0 16 14" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.6744 1.66537V5.66537M14.6744 5.66537H10.6744M14.6744 5.66537L11.5877 2.75871C10.6681 1.83853 9.47438 1.24216 8.18636 1.05947C6.89835 0.876774 5.58584 1.11765 4.44663 1.7458C3.30742 2.37395 2.40323 3.35534 1.87031 4.54208C1.33738 5.72883 1.2046 7.05663 1.49198 8.3254C1.77935 9.59418 2.4713 10.7352 3.46357 11.5765C4.45583 12.4178 5.69465 12.9138 6.99334 12.9898C8.29203 13.0657 9.58023 12.7176 10.6638 11.9977C11.7474 11.2778 12.5677 10.2253 13.0011 8.9987"
                                                      stroke="#10082F" stroke-width="1.5" stroke-linecap="round"
                                                      stroke-linejoin="round"/>
                                            </svg>

                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <app-reviews-pager [perPage]="3" [data]="latestResults"
                                   (pageChange)="onPager($event)"></app-reviews-pager>
            </div>
            <div class="col-md-1 col-12 p-0"></div>
            <div class="col-md-4 col-12 p-0">
                <h2>Нотатки</h2>
                <div class="notes-wrapper">
                    <div class="note" *ngFor="let note of latestList">
                        <div class="note-content">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. At cum deserunt dicta dignissimos,
                            doloribus ex facilis id impedit incidunt labore libero nihil omnis perferendis quasi,
                            repellat, repudiandae rerum voluptas. Impedit!
                        </div>
                        <div class="note-footer d-flex justify-content-between">
                            <div class="info">
                                <span><i class="bi bi-clock"></i>16:00</span>
                                <span><i class="bi bi-calendar"></i>17 березня 2024</span>
                            </div>
                            <button class="btn_primary_outline p-2 edit_button">
                                <svg class="m-0" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.5 20H19M15.25 5.54434C15.5815 5.1958 16.0312 5 16.5 5C16.7321 5 16.962 5.04807 17.1765 5.14147C17.391 5.23487 17.5858 5.37176 17.75 5.54434C17.9142 5.71692 18.0444 5.92179 18.1332 6.14728C18.222 6.37276 18.2678 6.61443 18.2678 6.85849C18.2678 7.10255 18.222 7.34422 18.1332 7.5697C18.0444 7.79519 17.9142 8.00006 17.75 8.17264L7.33333 19.1239L4 20L4.83333 16.4956L15.25 5.54434Z"
                                          stroke="#10082F" stroke-width="1.5" stroke-linecap="round"
                                          stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div>
                        <button class="btn btn_primary w-auto">
                            Додати нотатки
                            <i class="bi bi-chevron-right text-white"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-container">
        <div class="row">
            <div class="col-md-6 col-12">
                <h2>
                    AI Асистент
                </h2>
                <p>
                    Вітаємо вас у розділі "AI Асистент"! Цей інструмент допоможе вам автоматизувати та покращити вашу
                    роботу, забезпечуючи аналіз даних сесій та надання рекомендацій для подальшої терапії.
                    Використовуйте AI Асистента для створення транскриптів, інтерпретації результатів тестів та
                    отримання персоналізованих рекомендацій для ваших клієнтів.
                </p>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-3">
                <p class="text-muted">
                    Сьогодні
                </p>
                <ul class="list-group list-group-flush mb-3 ">
                    <li class="list-group-item">
                        <span>
                            <p>Звіт за минулий місяць по стану здоровʼя</p>
                        </span>
                    </li>
                </ul>
                <p class="text-muted">
                    Вчора
                </p>
                <ul class="list-group list-group-flush mb-2  ">
                    <li class="list-group-item">
                        <span>
                            <p>Звіт за минулий місяць по стану здоровʼя</p>
                        </span>
                    </li>
                    <li class="list-group-item">
                        <span>
                            <p>Звіт за минулий місяць по стану здоровʼя</p>
                        </span>
                    </li>
                </ul>

            </div>
            <div class="col-md-9 bg-light">
                <div class="chat-wrapper">
                    <div class="chat-cards row">
                        <div class=" col-md-6 col-12" *ngFor="let card of chatCards">
                            <div class="chat-card">
                                <div class="chat-card_title">
                                    Варіант питання 1
                                </div>
                                <p class="chat-card_content">
                                    Attentional bias refers to the phenomenon where...
                                </p>
                            </div>

                        </div>
                    </div>
                    <div class="chat-input-wrapper">
                        <div class="input-wrapper">
                            <input class="form-control" placeholder="Створити запит">
                        </div>
                        <div class="action-wrapper">
                            <button class="btn">
                                <i class="bi bi-arrow-up"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
